'use strict';
var unitas = unitas || {};
const themetexts = document.querySelectorAll('.js-block-theme-list-travel-item-text');
const showmoreThemeTextTriggers = document.querySelectorAll('.js-block-theme-list-travel-item-show-more');
const themeList = document.querySelector('#js-block-theme-list-travel');
const themeListHeight = document.querySelector('#js-block-theme-list-travel');
const showAllThemeListTrigger = document.querySelector('.js-block-theme-list-travel-see-all');

unitas.themelisttravel = unitas.themelisttravel || function () {
	function init() {
        setupShowMoreThemeList();
        setupShowMoreThemeText();
	}

    function setupShowMoreThemeList() {
        if(themeList && showAllThemeListTrigger) {
            const themeListHeight = themeList.getBoundingClientRect().height;
            showAllThemeListTrigger.addEventListener('click', function(){
                if (themeList.classList.contains('open')) {
                    themeList.classList.remove('open');
                    showAllThemeListTrigger.classList.remove('open');
                } else {
                    expandList();
                }
            });
        }
    }

    function setupShowMoreThemeText() {
        if(themetexts && showmoreThemeTextTriggers) {

            for (let i = 0; i < showmoreThemeTextTriggers.length; i++) {
                const currentTrigger = showmoreThemeTextTriggers[i];

                currentTrigger.addEventListener('click', function(e){
                    let clickedTrigger = e.currentTarget;
                    let parentItem = clickedTrigger.parentNode;
                    let textElement = parentItem.querySelector('.js-block-theme-list-travel-item-text');

                    if (textElement.style.maxHeight) {
                        textElement.style.maxHeight = null;
                        parentItem.classList.remove('open');
                    } else {
                        textElement.style.maxHeight = textElement.scrollHeight + "px";
                        parentItem.classList.add('open');
                    }
                });
            }

        }
    }

    function expandList() {
        themeList.classList.add('open');
        showAllThemeListTrigger.classList.add('open');
    }

	return {
		init : init
	};
}();